import { dropBoolean } from 'utils/drops';

const getMarcaFilterFields = () => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'marca',
    label: 'Marca',
    initial: true,
  },
  {
    name: 'ativo',
    label: 'Ativo',
    type: 'select',
    options: dropBoolean,
  },
];

export default getMarcaFilterFields;
